import React from 'react';
import { Link } from 'react-router';

export default class CustomerTabSidebar extends React.Component {
  render() {
    const { activeTab, context, id } = this.props;
    const urlBase = context === 'global' ? 'customers' : 'customer';
    return (
      <div className="customer-sidebar-section">
          <ul>
            <li className={activeTab === 'CustomerDetails' ? 'active' : 'not'}>
              <Link to={`/${urlBase}/${id}`}>
                Details
              </Link>
            </li>

            { id !== 'new' &&
              <span>
                <li className={activeTab === 'CustomerAgencies' ? 'active' : 'not'}>
                  <Link to={`/${urlBase}/${id}/agencies`}>
                    Agencies With Access
                  </Link>
                </li>
                <li className={activeTab === 'CustomerLocations' ? 'active' : 'not'}>
                  <Link to={`/${urlBase}/${id}/sub-account-list`}>
                    Sub-Accounts
                  </Link>
                </li>
                <li className={activeTab === 'CustomerUsers' ? 'active' : 'not'}>
                  <Link to={`/${urlBase}/${id}/userList`}>
                    Users
                  </Link>
                </li>
                <li className={activeTab === 'CustomerShapeSets' ? 'active' : 'not'}>
                  <Link to={`/${urlBase}/${id}/catchment-set-list`}>
                    Catchment Sets
                  </Link>
                </li>
                <li className={activeTab === 'CustomerInsightSets' ? 'active' : 'not'}>
                  <Link to={`/${urlBase}/${id}/insight-sets`}>
                    Insight Sets
                  </Link>
                </li>
              </span>
            }
            </ul>
            </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/customer/CustomerTabSidebar.js